export { default } from './emitter';

export type {
  EventListener,
  EventListenerParams,
  IEmitter,
} from './emitter.types';
